// Sample data for EcoControlFridges component
export const fridgeData = [
  { bin: 'Bin 001', name: 'Vaccine Fridge 1', temp: 'Temperature Calibration at 15°C', status: 'alert' },
  { bin: 'Bin 002', name: 'Vaccine Fridge 2', temp: 'Temperature Calibration at 18°C', status: 'ok' },
  { bin: 'Bin 003', name: 'Insulin Fridge 3', temp: 'Temperature Calibration at 18°C', status: 'ok' },
  { bin: 'Bin 004', name: 'Antibiotic Fridge 4', temp: 'Temperature Calibration at 18°C', status: 'ok' },
  // extra examples to enable pagination visually
  { bin: 'Bin 005', name: 'Vaccine Fridge 5', temp: 'Temperature Calibration at 18°C', status: 'ok' },
  { bin: 'Bin 006', name: 'Insulin Fridge 6', temp: 'Temperature Calibration at 18°C', status: 'ok' },
  { bin: 'Bin 007', name: 'Antibiotic Fridge 7', temp: 'Temperature Calibration at 18°C', status: 'ok' },
  { bin: 'Bin 008', name: 'Vaccine Fridge 8', temp: 'Temperature Calibration at 18°C', status: 'ok' },
];

export const fridgeContentsData = [
  { id: 'ID04', name: 'Pfizer-BioNTech COVID-19', batch: 'PFZ20250226', sku: 'VAC-PFZ-001-CO19', category: 'Vaccine', qty: 120, exp: '2024-06-30', unity: 'Vials' },
  { id: 'ID02', name: 'Hepatitis B', batch: 'HBP20250101', sku: 'VAC-HBM-2023-1', category: 'Vaccine', qty: 10, exp: '2024-08-15', unity: 'Vials' },
  { id: 'ID06', name: 'Insulin Glargine', batch: 'INS20241108', sku: 'MED-INS-GLA-012', category: 'Insulin', qty: 10, exp: '2025-05-10', unity: 'Syringes' },
  { id: 'ID01', name: 'MMR Vaccine', batch: 'MMR20241215', sku: 'VAC-MMR-009', category: 'Vaccine', qty: 10, exp: '2025-10-20', unity: 'Vials' },
];

export const fridgeContentsColumns = [
  { header: 'Item ID', accessor: 'id' },
  { header: 'Item Name', accessor: 'name' },
  { header: 'Batch', accessor: 'batch' },
  { header: 'SKU', accessor: 'sku' },
  { header: 'Category', accessor: 'category' },
  { header: 'Qty', accessor: 'qty' },
  { header: 'Expiry Date', accessor: 'exp' },
  { header: 'Unity', accessor: 'unity' },
];

export const dropdownOptions = {
  supplier: ["1"],
  unity: ['Vials','Injections','Syringes','Box','Pack','Bottle'],
  category: ["Vaccine","Insulin","Antibiotics"],
  range: ["Day","Week","Month"],
  weekday: ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]
};

export const defaultFridgeValues = {
  binNumber: "",
  temperature: "",
  serialNumber: "",
  supplier: "1",
  totalQty: 10,
  uploadFile: null,
  itemName: "",
  sku: "",
  batch: "",
  qty: 10,
  unity: "",
  expiry: null
};
